<template>
<v-card>
    <v-toolbar flat tabs color="grey lighten-3">
        <v-toolbar-side-icon @click="$emit('close')">
            <v-icon color="primary">close</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Horário de funcionamento</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
        <v-layout wrap>
            <v-flex xs12 xl6 v-for="day in days" :key="day.name">
                <v-list class="transparent">
                    <v-subheader class="title">{{day.name}}</v-subheader>
                    <v-list-tile v-if="day.ranges.length==0 && !day.noClose">
                        <span class="subheading grey--text">fechado</span>
                        <v-list-tile-action>
                            <v-btn flat small color="accent" @click="day.ranges.push({start:null,end:null})">
                                alterar
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                    <template v-if="!day.noClose">
                        <sp-ranger-picker
                            v-for="(range, index) in day.ranges" :key="index"
                            v-model="day.ranges[index]" @delete="day.ranges.splice(index,1)"
                        >
                        </sp-ranger-picker>
                    </template>
                    <v-list-tile v-if="day.ranges.length >= 1 && !day.noClose">
                        <v-btn flat color="accent" @click="day.ranges.push({start:null,end:null})">
                            Adicionar outros horários de funcionamento
                        </v-btn>
                    </v-list-tile>
                    <v-list-tile>
                        <v-checkbox
                        v-model="day.noClose"
                        label="Aberto 24 horas"
                        ></v-checkbox>
                    </v-list-tile>
                    <v-divider></v-divider>
                </v-list>
            </v-flex>
        </v-layout>
    </v-card-text>
    <v-card-actions>
        <v-layout row justify-center>
            <v-flex xs4>
                <v-btn color="success" large block class="mb-3" :loading="loading" @click="save">
                    Salvar
                </v-btn>
            </v-flex>
        </v-layout>
    </v-card-actions>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'

import SpRangerPicker from "./SpRangerPicker";

export default {
    components:{
        SpRangerPicker
    },
    data(){
        return{
            loading:false,
            days:[
                {name:"Domingo",ranges:[],noClose:false},
                {name:"Segunda-feira",ranges:[],noClose:false},
                {name:"Terça-feira",ranges:[],noClose:false},
                {name:"Quarta-feira",ranges:[],noClose:false},
                {name:"Quinta-feira",ranges:[],noClose:false},
                {name:"Sexta-feira",ranges:[],noClose:false},
                {name:"Sábado",ranges:[],noClose:false},
            ],
            daysDefault:[
                {name:"Domingo",ranges:[],noClose:false},
                {name:"Segunda-feira",ranges:[],noClose:false},
                {name:"Terça-feira",ranges:[],noClose:false},
                {name:"Quarta-feira",ranges:[],noClose:false},
                {name:"Quinta-feira",ranges:[],noClose:false},
                {name:"Sexta-feira",ranges:[],noClose:false},
                {name:"Sábado",ranges:[],noClose:false},
            ],
            horarioFuncionamento:false
        }
    },
    mounted(){
        this.convertRanges()
    },
    computed: {
        ...mapGetters([
            'restaurant'
        ]),
    },
    methods:{
        convertRanges(v){
            const ranges = this.restaurant.horario_funcionamento
            this.days = JSON.parse(JSON.stringify(this.daysDefault))
            ranges.forEach(range => {
                let h1 = range.hora1.split(":")
                h1 = (h1[1]*1) + ((h1[0]=="00"?"24":h1[0])*60)
                let h2 = range.hora2.split(":")
                h2 = (h2[1]*1) + ((h2[0]=="00"?"24":h2[0])*60)
                
                if(range.dia1 != undefined){
                    for(let i=range.dia1;i<=6+range.dia1;i++){
                        this.days[(i>6)?i-7:i].noClose = h1 - h2 == 1
                        if(!this.days[(i>6)?i-7:i].noClose){
                            this.days[(i>6)?i-7:i].ranges.push({start:range.hora1,end:range.hora2})
                        }
                    }
                }else{
                        this.days[range.dia2].noClose = h1 - h2 == 1
                        if(!this.days[range.dia2].noClose){
                            this.days[range.dia2].ranges.push({start:range.hora1,end:range.hora2})
                        }
                }
            });
        },
        deleteRange(index,day){
            day.ranges.splice(index,1)
        },
        setRange(start,end,index,day){
            day.ranges[index] = {start,end}
        },
        save(){
            this.loading = true
            const data = {
                horario_funcionamento:[]
            }
            this.days.forEach((day,index) => {
                if(day.noClose){
                    data.horario_funcionamento.push({
                        dia2:index,
                        hora1:"00:00",
                        hora2:"23:59"
                    })
                }else{
                    day.ranges.forEach(range => {
                        if(range.start && range.end){
                            data.horario_funcionamento.push({
                                dia2:index,
                                hora1:range.start,
                                hora2:range.end
                            })
                        }
                    });
                }
            });
            this.loading = false
            this.$store.dispatch('modifyRestaurant',data).then(res=>{
                this.loading = false
                this.$emit('close')
            }).catch(err=>{
                this.error = err
                console.log(err)
                this.loading = false
            })
        }
    }

}
</script>

<style>

</style>